// Single source for the account id the client declares on every /api/customer/* request
// (sent as the X-Account-Id header). Kept in its own dependency-free module so the
// low-level fetch wrapper can read it without importing the session store, which would
// create a circular import.

let requestAccountId: number | null = null;
let mismatchHandler: (() => void) | null = null;

export function setRequestAccountId(id: number | null): void {
	requestAccountId = id;
}

export function getRequestAccountId(): number | null {
	return requestAccountId;
}

// The session store registers a handler here to re-sync when the server reports that the
// account the client declared no longer matches the server's view.
export function setAccountMismatchHandler(fn: (() => void) | null): void {
	mismatchHandler = fn;
}

export function notifyAccountMismatch(): void {
	mismatchHandler?.();
}
